// Module
var code = `<action-card headline="yourGrowers.HEADLINE"> <ul class="divide-y divide-gray-200"> <li class="py-2" ng-repeat="grower in \$ctrl.growers| orderBy: 'name'"> <ui-link state="app.growers.grower.manage" params="{grower_sid: grower.sid}" content="{{grower.name}}"></ui-link> </li> </ul> </action-card> `;
// Exports
export default code;